<template>
    <div class="forgot-password-container" v-if="!isSubmitted">
      <h2>忘記密碼</h2>
      <p>輸入手機號碼，我們將發送簡訊至該門號</p>
      <form @submit.prevent="handleForgotPassword">
        <div class="form-group">
          <input
            type="text"
            id="phone"
            v-model="phone"
            placeholder="0920222222"
            required
          />
        </div>
        <button type="submit" class="submit-button">送出</button>
      </form>
    </div>
  
    <!-- Success Message -->
    <div class="success-container" v-else>
      <h2>發送成功</h2>
      <div class="success-icon">
        <img src="@/assets/icon_success.png" alt="Success Icon" />
      </div>
      <p>系統已經發送簡訊至您的手機<br>請查看後重新設定密碼</p>
      <p class="back-to-login" @click="backToLogin">前往登入帳號</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ForgotPassword',
    data() {
      return {
        phone: '',
        isSubmitted: false, // Track form submission state
      };
    },
    methods: {
      handleForgotPassword() {
        // Set isSubmitted to true to show the success message
        this.isSubmitted = true;
      },
      backToLogin() {
        // Navigate back to the login page
        this.$router.push('/login-page');
      },
    },
  };
  </script>
  
  <style scoped>
  .forgot-password-container, .success-container {
    max-width: 343px;
    margin: 0 auto;
    padding: 40px 20px;
    text-align: center;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  h2 {
    color: #008000;
    font-size: 2rem;
    margin-bottom: 20px;
  }
  
  p {
    color: #333;
    font-size: 1rem;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  input[type="text"] {
    width: 100%;
    padding: 15px;
    font-size: 1rem;
    border: 2px solid #008000;
    border-radius: 8px;
    box-sizing: border-box;
  }
  
  .submit-button {
    width: 100%;
    padding: 15px;
    font-size: 1.1rem;
    background-color: #008000;
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
  }
  
  .submit-button:hover {
    background-color: #005f00;
  }
  
  .success-icon {
    margin: 20px 0;
  }
  
  .success-icon img {
    width: 50px;
    height: 50px;
  }
  
  .back-to-login {
    color: #008000;
    font-size: 1rem;
    cursor: pointer;
    text-decoration: underline;
  }
  
  /* Responsive styles for screens smaller than 560px */
  @media (max-width: 560px) {
    .forgot-password-container, .success-container {
      width: 100%;
      padding: 20px 10px;
    }
  
    h2 {
      font-size: 1.5rem;
    }
  
    p {
      font-size: 0.9rem;
    }
  
    .submit-button {
      font-size: 1rem;
      padding: 12px;
    }
  
    input[type="text"] {
      padding: 12px;
    }
  }
  </style>
  